import { render } from "./Modal.vue?vue&type=template&id=8f280b30&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=8f280b30&scoped=true&lang=css"

import exportComponent from "/Users/niq/Documents/Project Apps/TMI/Helpdesk App/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f280b30"]])

export default __exports__